// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.left[data-v-8488a51c] {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  font-size: 14px;\n  font-weight: 600;\n}\n.left[data-v-8488a51c] .text {\n  margin-left: 7px;\n}\n.left[data-v-8488a51c] > * {\n  margin-right: 25px;\n  white-space: nowrap;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
